import React, { useEffect } from "react";

interface CustomWindow extends Window {
  Tawk_API?: any;
  Tawk_LoadStart?: Date;
}
declare const window: CustomWindow;

const TawkChat: React.FC = () => {
  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    if (!document.getElementById("tawk-script")) {
      const s1 = document.createElement("script");
      const s0 = document.getElementsByTagName("script")[0];

      s1.id = "tawk-script";
      s1.async = true;
      s1.src = "https://embed.tawk.to/6a1838b765740f1c34577cb7/1jpn9r38m";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");

      if (s0 && s0.parentNode) {
        s0.parentNode.insertBefore(s1, s0);
      } else {
        document.head.appendChild(s1);
      }
    }

    const initChat = () => {
      if (window.Tawk_API && typeof window.Tawk_API.showWidget === "function") {
        window.Tawk_API.showWidget();
      }
    };

    if (window.Tawk_API && typeof window.Tawk_API.showWidget === "function") {
      initChat();
    } else {
      window.Tawk_API.onLoad = initChat;
    }

    return () => {
      if (window.Tawk_API) {
        try {
          if (typeof window.Tawk_API.minimize === "function")
            window.Tawk_API.minimize();
          if (typeof window.Tawk_API.hideWidget === "function")
            window.Tawk_API.hideWidget();
        } catch (e) {
          console.error("Erro ao esconder widget do Tawk", e);
        }
      }

      const tawkElements = document.querySelectorAll(
        'iframe[id^="tawkChatNode"], div[id^="tawkchat"], .tawk-minimized, .tawk-chat-window',
      );

      tawkElements.forEach((el) => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    };
  }, []);

  return null;
};

export default TawkChat;
